import Mh1PersianDatePicker from "./Mh1PersianDatePicker";
import numeric from "../../utils/NumericFunction";
import React from "react";
import ReactDOM from "react-dom/client";
import Editor from "./Editor";
import {ROW_TYPE} from "../FormNew/RenderInput";


export const dNoneToExceptionFields = (formDom, exceptionFields) => {
  exceptionFields.forEach(id => {
    formDom.querySelector('#' + id).classList.add('d-none');
    // formDom.querySelector(`label[for="${id}"]`).classList.add('d-none');
    const labelElement = formDom.querySelector(`label[for="${id}"]`);
    if (labelElement) {
      if (labelElement?.classList) {
        labelElement?.classList.add('d-none');
      } else {
        labelElement.setAttribute("class", "d-none")
      }
    }

  })
}


// dude i know this is Terrible, I has to paste this  dirty codes here  it show Date Box
// if you Have a Better solution I Ask You To Do it Please
var _mh1PersianDatePicker = new Mh1PersianDatePicker();

Mh1PersianDatePicker.Show = function (textBox, today, holidays) {
  _mh1PersianDatePicker.show(textBox, today, holidays);
};

let today = new Date().toLocaleDateString("fa-IR", {
  year: "numeric", month: "2-digit", day: "2-digit",
});
today = numeric.p2e(today);


function plzForeEachDear(value, index) {
  // formDomObject.querySelector(`#${value.id}`).value = formDomObject.querySelector(`#${value.id}`).value.replaceAll(",","");
  value.addEventListener("click", function () {
    Mh1PersianDatePicker.Show(this, today);
  });
}

function addWidthToSelectOption(formDOM) {
  const selectFields = formDOM.getElementsByClassName("custom-select");
  if (selectFields !== null) {
    for (let i = 0; i < selectFields.length; i++) {
      selectFields[i].classList.add("minWidth200");
    }
  }
}

function addStyleToInputFields(formDOM, isEditing) {
  const inputFields = formDOM.getElementsByTagName("input");
  if (inputFields !== null) {
    for (let i = 0; i < inputFields.length; i++) {
      inputFields[i].classList.add("w-100");
      inputFields[i].classList.add("minWidth200");
      inputFields[i].classList.add("text-center");
      inputFields[i].style.direction = "ltr";
      //  add current system Time To TimeFields
      if (inputFields[i].classList.contains("timepicker-ui-input")) {
        inputFields[i].classList.add("width130");

        if (isEditing !== undefined && isEditing === false) {
          let today = new Date();
          inputFields[i].value = ("0" + today.getHours()).slice(-2) + ":" + ("0" + today.getMinutes()).slice(-2) + ":" + ("0" + today.getSeconds()).slice(-2);
        }
      }
    }
  }

  const textAreaFields = formDOM.getElementsByTagName("textarea");

  console.log(textAreaFields)

  for (let i = 0; i < textAreaFields.length; i++) {

    if (process.env.REACT_APP_SHOULD_I_EXPAND_OBJ49 === "yes") {

      // textAreaFields[i].classList.contains("obj-49") && textAreaFields[i].classList.add("w-100");
      textAreaFields[i].classList.contains("obj-49") && textAreaFields[i].parentElement.parentElement.parentElement.classList.add("addFullWidthToTextArea")
    }

  }


}

function addDatePickerToDateFields(formDOM) {

  let numberFieldsClassplz = formDOM.querySelectorAll(".obj-15");
  if (numberFieldsClassplz !== null) {
    numberFieldsClassplz.forEach(plzForeEachDear);
  }
}

export const addDateTimeEtcToFormDom = (formDOM, isEditing) => {
  if (formDOM !== null) {
    addWidthToSelectOption(formDOM)
    addStyleToInputFields(formDOM, isEditing)

    addDatePickerToDateFields(formDOM)
  }


  if (formDOM !== null) {

  }
}
export const needToUploadFiles = (selectedFileToUpload: [], formDataObject) => {


  //خب اجباری بودنش که توسط  ولیدیشن چک میشه
  //

  return selectedFileToUpload.length > 0;


  //اینجا باید چک کنیم که آیا فایل آپلودی داریم یا نه
  //اگه داریم آیا اجباری هست یا نه
  // اگه اجباری بود پس حتما باید
  //  چگ گنم که پر باشه.
  // اگه پر بود
  //so i have to change value of needToUpload to TRUE;


  //formDomObject.querySelectorAll(".obj-41").length > 0 ? (needToUpload = true) : (needToUpload = false);


}


export const addUploadFunctionality = (formDOM_current, OnChangeAddToStateFunction) => {
  // if there is a formDOM.current please make changes onChange
  if (formDOM_current) {
    let uploadedNodeList = formDOM_current.querySelectorAll(".obj-41");
    if (uploadedNodeList.length > 0) {
      uploadedNodeList.forEach(OnChangeAddToStateFunction);
    }

    // let deleteBtnOnEditForm = formDOM.current.querySelectorAll(".delete-btn");
    // if (deleteBtnOnEditForm.length > 0) {
    //     deleteBtnOnEditForm.forEach(addDeleteFunctionToEachBtn)
    //
    // }
  }
}

export const makeEmptyIfNoneUploadFile = (formData, formData_current) => {


  formData_current.querySelectorAll('.obj-41').forEach(fileInput => {
    if (formData[0][fileInput.name].size === 0) {
      formData[0][fileInput.name] = "";
    }

  })

  return formData


}


export const addEditor = ({formDom}) => {
  console.log(formDom);

  const editorsFields = formDom?.querySelectorAll('.obj-377');

  if (editorsFields) {
    editorsFields?.forEach((editorField) => {


      const myRoot = ReactDOM.createRoot(editorField);
      myRoot.render(<><Editor/></>)

    });
  }
};

